module.exports = require("chained-function");


//////////////////
// WEBPACK FOOTER
// external "chained-function"
// module id = 10
// module chunks = 0